import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})

export class EncryptService {
    constructor() { }

    // The set method is use for encrypt the value.
    set(key, value) {
        let conversionOutput = CryptoJS.AES.encrypt(value.trim(), key.trim()).toString();
         return conversionOutput.toString();
    }

}